import { useCallback, useState } from "react"
import { SidebarNav } from "@/components/Layout/SidebarNav"
import { SidebarAccount } from "@/components/Layout/SidebarAccount"

type Props = {
  children: JSX.Element | JSX.Element[]
}

export const Layout = ({ children }: Props) => {
  const [isOpenNav, setIsOpenNav] = useState(false)
  const toggleNav = useCallback(() => {
    setIsOpenNav(!isOpenNav)
  }, [isOpenNav])

  const [isOpenSidebar, setIsOpenSidebar] = useState(false)
  const toggleSidebar = useCallback(() => {
    setIsOpenSidebar(!isOpenSidebar)
  }, [isOpenSidebar])

  const onBgClick = useCallback(() => {
    setIsOpenNav(false)
    setIsOpenSidebar(false)
  }, [])

  return (
    <div className="blue-bg" >
      <div className={`background ${isOpenNav || isOpenSidebar ? "active" : ""}`} onClick={onBgClick} />
      <header>
        <SidebarNav isOpen={isOpenNav} toggleNav={toggleNav} onClose={() => setIsOpenNav(false)} />
        <SidebarAccount onClose={() => setIsOpenSidebar(false)} isOpen={isOpenSidebar} toggleSidebar={toggleSidebar} />
      </header>
      <main className="main-content !pb-8">{children}</main>
    </div>
  )
}
